<script setup>
import { useI18n } from 'vue-i18n';
import { useQuranSettings } from '@/composables/quran/useQuranSettings';
import { PLAYBACK_RATES } from '@/utils/quran/audio';

/** Playback speed, one tap per step: 0.75× → 1× → 1.25× → 1.5×. */
const { t } = useI18n();
const settings = useQuranSettings();

function cycle() {
  const i = PLAYBACK_RATES.indexOf(settings.rate);
  settings.rate = PLAYBACK_RATES[(i + 1) % PLAYBACK_RATES.length];
}
</script>

<template>
  <button
    type="button"
    class="h-8 min-w-[52px] px-2.5 rounded-full border border-white/15 text-xs font-bold tabular-nums transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-deen-gold"
    :class="settings.rate === 1 ? 'text-white/70 hover:text-white hover:bg-white/10' : 'text-deen-ink bg-deen-gold border-deen-gold'"
    :aria-label="t('quran.player.speed')"
    :title="t('quran.player.speed')"
    @click="cycle"
  >{{ settings.rate }}×</button>
</template>
